export const DATE_FORMATS = {
  keys: 'yyyy-MM-dd',
  dayMonth: 'dd/MM',
  standard: 'dd/MM/yyyy',
  standardWithTime: 'dd/MM/yyyy - HH:mm',
  standardWithTimeTwelveHour: 'dd/MM/yyyy - hh:mm aa',
  standardWithTimeAndSeconds: 'dd/MM/yyyy HH:mm:ss',
  filenameStamp: 'yyyy-MM-dd_HH-mm-ss',
  rfc3339: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
  pretty: 'd LLLL yyyy',
  prettyWithTime: 'd LLLL yyyy - HH:mm',
  countdown: 'm:ss',
  unixSeconds: 't',
} as const;
